export const initialState = {
  products: [],
  requests: [],
  filters: {},
  loading: false,
};

// Función para cargar datos desde localStorage
export const loadStateFromStorage = () => {
  try {
    const serializedState = localStorage.getItem("tattersall-app-state");
    if (serializedState === null) {
      return initialState;
    }
    const parsedState = JSON.parse(serializedState);

    // Validar que la estructura sea correcta
    return {
      ...initialState,
      ...parsedState,
      loading: false, // Siempre resetear loading
    };
  } catch (err) {
    console.warn("Error loading state from localStorage:", err);
    return initialState;
  }
};

// Función para guardar datos en localStorage
export const saveStateToStorage = (state) => {
  try {
    // Solo guardar datos importantes, no loading ni datos temporales
    const stateToSave = {
      products: state.products,
      requests: state.requests,
      filters: state.filters,
    };
    const serializedState = JSON.stringify(stateToSave);
    localStorage.setItem("tattersall-app-state", serializedState);
  } catch (err) {
    console.warn("Error saving state to localStorage:", err);
  }
};

export const appReducer = (state, action) => {
  let newState;

  switch (action.type) {
    case "SET_PRODUCTS":
      newState = { ...state, products: action.payload };
      break;
    case "SET_REQUESTS":
      newState = { ...state, requests: action.payload };
      break;
    case "ADD_REQUEST":
      newState = { ...state, requests: [...state.requests, action.payload] };
      break;
    case "UPDATE_REQUEST":
      newState = {
        ...state,
        requests: state.requests.map((req) =>
          req.id === action.payload.id ? action.payload : req
        ),
      };
      break;
    case "SET_LOADING":
      newState = { ...state, loading: action.payload };
      break;
    case "SET_FILTERS":
      newState = { ...state, filters: action.payload };
      break;
    case "CLEAR_STORAGE":
      localStorage.removeItem("tattersall-app-state");
      newState = initialState;
      break;
    default:
      newState = state;
  }

  // Guardar en localStorage después de cada cambio (excepto loading)
  if (action.type !== "SET_LOADING") {
    saveStateToStorage(newState);
  }

  return newState;
};
